// Icons
import AviatorIcon from "assets/icons/glory/aviator.svg?react";
import HOTIcon from "assets/icons/glory/HOT.svg?react";
import Arkade from "assets/icons/glory/menu_arkada.svg?react";
import Bakkara from "assets/icons/glory/menu_bakkara.svg?react";
import Blackjack from "assets/icons/glory/menu_blackjack.svg?react";
import Bingo from "assets/icons/glory/menu_bingo.svg?react";
import Favorite from "assets/icons/glory/menu_favorite.svg?react";
import Momentum from "assets/icons/glory/menu_momentum.svg?react";
import Lottery from "assets/icons/glory/menu_lottery.svg?react";
import Keno from "assets/icons/glory/menu_keno.svg?react";
import VideoPoker from "assets/icons/glory/menu_video-poker.svg?react";
import Popular from "assets/icons/glory/menu_popular.svg?react";
import Poker from "assets/icons/glory/menu_poker.svg?react";
import Roulette from "assets/icons/glory/menu_roulette.svg?react";
import Other from "assets/icons/glory/menu_other.svg?react";
import Slots from "assets/icons/glory/menu_slots.svg?react";
import Skretch from "assets/icons/glory/menu_skretch.svg?react";
import VSport from "assets/icons/glory/menu_vsport.svg?react";
import Table from "assets/icons/glory/menu_table.svg?react";
import Telegram from "assets/icons/telegram.svg";
import Instagram from "assets/icons/instagram.svg";
import Facebook from "assets/icons/facebook.svg";
import TelegramDesktop from "assets/icons/glory/telegram.svg";
import InstagramDesktop from "assets/icons/glory/instagram_logo.svg";
import FacebookDesktop from "assets/icons/glory/facebook.svg";

//

// Types
import { NAVIGATION_PROPERTIES } from "constants/navigation/topNavigationDesktop";

// Url
import config from "url/config";
import url from "url/index";
import { CATEGORIES_ENUMS } from "./navigation/categories";

type TopNavigationTypes = {
  link: string;
  name?: string;
  nameImage?: JSX.Element;
  label?: JSX.Element;
};

export const TOP_NAVIGATION: TopNavigationTypes[] = [
  {
    link: "",
    name: "Казино",
  },
  {
    link: "",
    name: "Live-казино",
  },
  // {
  //   link: "",
  //   name: "V-спорт",
  // },
  {
    link: "",
    name: "Jackpot",
  },
  {
    link: "",
    nameImage: <AviatorIcon />,
    label: <HOTIcon />,
  },
];

enum SIDEBAR_NAVIGATION_ENUMS {
  POPULAR,
  FAVORITE,
  SLOTS,
  TABLE,
  LOTTERY,
  VIDEO_POKER,
  ROULETTE,
  BLACKJACK,
  SCRETCH,
  POKER,
  BINGO,
  VSPORT,
  BAKKARA,
  ARKADE,
  KENO,
  MOMENTUM,
  OTHER,
}

export const SIDEBAR_NAVIGATION_DESKTOP = [
  {
    id: SIDEBAR_NAVIGATION_ENUMS.POPULAR,
    title: "casino.sidebar.popular",
    icon: <Popular />,
    url: "/",
  },
  {
    id: SIDEBAR_NAVIGATION_ENUMS.FAVORITE,
    title: "casino.sidebar.favorite",
    icon: <Favorite />,
    url: "/",
  },
  {
    id: SIDEBAR_NAVIGATION_ENUMS.SLOTS,
    title: "casino.sidebar.slots",
    icon: <Slots />,
    url: "/",
  },
  {
    id: SIDEBAR_NAVIGATION_ENUMS.TABLE,
    title: "casino.sidebar.table",
    icon: <Table />,
    url: "/",
  },
  {
    id: SIDEBAR_NAVIGATION_ENUMS.LOTTERY,
    title: "casino.sidebar.lottery",
    icon: <Lottery />,
    url: "/",
  },
  {
    id: SIDEBAR_NAVIGATION_ENUMS.VIDEO_POKER,
    title: "casino.sidebar.poker.video",
    icon: <VideoPoker />,
    url: "/",
  },
  {
    id: SIDEBAR_NAVIGATION_ENUMS.ROULETTE,
    title: "casino.sidebar.poker.roulette",
    icon: <Roulette />,
    url: "/",
  },
  {
    id: SIDEBAR_NAVIGATION_ENUMS.BLACKJACK,
    title: "casino.sidebar.poker.blackjack",
    icon: <Blackjack />,
    url: "/",
  },
  {
    id: SIDEBAR_NAVIGATION_ENUMS.SCRETCH,
    title: "casino.sidebar.poker.scratch",
    icon: <Skretch />,
    url: "/",
  },
  {
    id: SIDEBAR_NAVIGATION_ENUMS.POKER,
    title: "casino.sidebar.poker.poker",
    icon: <Poker />,
    url: "/",
  },
  {
    id: SIDEBAR_NAVIGATION_ENUMS.BINGO,
    title: "casino.sidebar.poker.bingo",
    icon: <Bingo />,
    url: "/",
  },
  {
    id: SIDEBAR_NAVIGATION_ENUMS.VSPORT,
    title: "casino.sidebar.poker.sport",
    icon: <VSport />,
    url: "/",
  },
  {
    id: SIDEBAR_NAVIGATION_ENUMS.BAKKARA,
    title: "casino.sidebar.poker.bakkara",
    icon: <Bakkara />,
    url: "/",
  },
  {
    id: SIDEBAR_NAVIGATION_ENUMS.ARKADE,
    title: "casino.sidebar.poker.arcade",
    icon: <Arkade />,
    url: "/",
  },
  {
    id: SIDEBAR_NAVIGATION_ENUMS.KENO,
    title: "casino.sidebar.poker.keno",
    icon: <Keno />,
    url: "/",
  },
  {
    id: SIDEBAR_NAVIGATION_ENUMS.MOMENTUM,
    title: "casino.sidebar.poker.instant",
    icon: <Momentum />,
    url: "/",
  },
  {
    id: SIDEBAR_NAVIGATION_ENUMS.OTHER,
    title: "casino.sidebar.poker.other",
    icon: <Other />,
    url: "/",
  },
];

export enum FOOTER_NAVIGATION_ENUMS {
  LIVE,
  AVIATOR,
  WELCOME_BONUS,
  TOURNAMENTS,
  ABOUT,
  CONDITIONS,
  KYCAML,
  PRIVACY,
  COOKIES,
  GAMBLING,
  SUPPORT,
  PARTNERS,
  HOURS,
  TELEGRAM,
  INSTA,
  FACEBOOK,
}

export type FooterNavigationType = {
  id: number;
  name: string;
  link?: string;
  property?: NAVIGATION_PROPERTIES;
  value?: string[];
  gameId?: string;
};

export const FOOTER_CASINO: FooterNavigationType[] = [
  {
    id: FOOTER_NAVIGATION_ENUMS.LIVE,
    name: "footer.live",
    link: url.routes.casino.category([CATEGORIES_ENUMS.LIVE_CASINO]),
  },
  {
    id: FOOTER_NAVIGATION_ENUMS.AVIATOR,
    name: "footer.aviator",
    gameId: "3193817929df4f8481eb141698d331f0",
  },
  {
    id: FOOTER_NAVIGATION_ENUMS.WELCOME_BONUS,
    name: "menu.left.welcomebonus",
    link: url.routes.info.welcomeBonus(),
  },
  {
    id: FOOTER_NAVIGATION_ENUMS.TOURNAMENTS,
    name: "footer.tournaments",
    link: config.tournament.root,
  },
];

export const FOOTER_INFORMATION: FooterNavigationType[] = [
  {
    id: FOOTER_NAVIGATION_ENUMS.ABOUT,
    name: "footer.us",
    link: url.routes.info.about(),
  },
  {
    id: FOOTER_NAVIGATION_ENUMS.CONDITIONS,
    name: "footer.conditions",
    link: url.routes.info.conditions(),
  },
  {
    id: FOOTER_NAVIGATION_ENUMS.KYCAML,
    name: "footer.AMLKYC",
    link: url.routes.info.kycaml(),
  },
  {
    id: FOOTER_NAVIGATION_ENUMS.PRIVACY,
    name: "footer.privacy",
    link: url.routes.info.privacy(),
  },
  {
    id: FOOTER_NAVIGATION_ENUMS.GAMBLING,
    name: "footer.responsiblegame",
    link: url.routes.info.responsiblegame(),
  },
  {
    id: FOOTER_NAVIGATION_ENUMS.COOKIES,
    name: "footer.cookie",
    link: url.routes.info.cookies(),
  },
  // {
  //     id: FOOTER_NAVIGATION_ENUMS.PARTNERS,
  //     name: 'footer.partners',
  //     link: '/',
  // },
];

export type FooterSocial = (project: "glory" | "banger") => FooterSocialType[];

export type FooterSocialType = {
  id: number;
  icon: string;
  iconDesktop: string;
  link: string;
};

export const FOOTER_SOCIAL: FooterSocial = (project: "glory" | "banger") => [
  {
    id: FOOTER_NAVIGATION_ENUMS.TELEGRAM,
    icon: Telegram,
    iconDesktop: TelegramDesktop,
    link: `sidebar.social.link.telegram.${project}`,
  },
  {
    id: FOOTER_NAVIGATION_ENUMS.INSTA,
    icon: Instagram,
    iconDesktop: InstagramDesktop,
    link: `sidebar.social.link.instagram.${project}`,
  },
];

export const FOOTER_FACEBOOK: FooterSocial = (project: "glory" | "banger") => [
  {
    id: FOOTER_NAVIGATION_ENUMS.FACEBOOK,
    icon: Facebook,
    iconDesktop: FacebookDesktop,
    link: `sidebar.social.link.facebook.${project}`,
  },
];
